import axios from "axios";

import { ApiConversation } from "../shared/interfaces";
import {
    comparatorConversationOldestToNewestUpdate,
    comparatorMessageOldToNew,
} from "../util/objectUtil";
import { hasNoConversations } from "../hooks/configuration";

export const ConversationApi = {
    getConversation: async (id: string): Promise<ApiConversation> => {
        const resp = await axios.get(`/api/conversation/${id}`);
        return resp.data;
    },

    getAllConversations: async (): Promise<ApiConversation[]> => {
        if (hasNoConversations()) {
            return [];
        }

        const resp = await axios.get("/api/conversation");
        const conversations: ApiConversation[] = resp.data.sort(
            comparatorConversationOldestToNewestUpdate,
        );
        conversations.forEach((c) => c.messages.sort(comparatorMessageOldToNew));
        return conversations;
    },

    createConversation: async (message: string, messageType: string): Promise<ApiConversation> => {
        const resp = await axios.post("/api/conversation", {
            message,
            messageType,
        });
        return resp.data;
    },
};
